import { render, staticRenderFns } from "./FrequentQuestions.vue?vue&type=template&id=6f07c0df"
import script from "./FrequentQuestions.vue?vue&type=script&lang=js"
export * from "./FrequentQuestions.vue?vue&type=script&lang=js"
import style0 from "./FrequentQuestions.vue?vue&type=style&index=0&id=6f07c0df&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports